import React from 'react';
import { withRouter } from 'react-router-dom';
import ResultItemSC, { /* ResultHeadlineSC, */ FaqLinkSC } from './result-item.styled';

const ResultItem = ({ history, faqId, question }) => {
  const handleFaqClick = (faqId) => {
    history.push(`/faq/detail/${faqId}`);
  };

  return (
    <ResultItemSC>
      {/*     <ResultHeadlineSC>
        
      </ResultHeadlineSC> */}

      <FaqLinkSC onClick={() => handleFaqClick(faqId)}>{question}</FaqLinkSC>
    </ResultItemSC>
  );
};

export default withRouter(ResultItem);
